<template>
  <div class="J_map-box">
    <div id="mapBox"></div>
  </div>
</template>

<script>
  import mapboxgl from 'mapbox-gl';

  // let icon = require('../../static/images/lo.png');
  // let svg = ['<svg xmlns="http://www.w3.org/2000/svg" width="80" height="40"><rect width="', 80, '" height="', 25, '" rx="2" ry="2" stroke="', '#0097FF', '" stroke-width="', 1, '" fill="', '#0097FF', '"/><polygon points="34,23,48,23,41,33" style="fill:#0097FF; stroke: #0097FF; stroke-width: 1"/></svg>'];

  export default {
    name: 'map-box',
    // props: ['long_lat'],
    props: {
      locationData: {
        type: Array,
        default: [],
      },
      singleLocation: Boolean,  // 是否是单个地区
      randomFlag: 0, // 随机数，动态生成地图
    },
    data() {
      return {
        points: [],
        infobox: null,

        mapBox: null,
      };
    },
    computed: {
      lanType(){
        return +window.localStorage.getItem('lan_type');
      },
    },
    watch: {
      randomFlag(){
        this.initMap();
      }
    },
    mounted () {
      this.initMap();

      // this.$nextTick(() => {
      //   if(this.long_lat.length){
      //     this.initMap();
      //   }else {
      //     setTimeout(() => {
      //       this.initMap();
      //     },1000)
      //   }
      // })
    },
    methods: {
      initMap () {
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmFpZ29sZiIsImEiOiJjazl4ajQ1c3kwMTljM21zNDIzMDR4NWYxIn0.wKBfx1ZlbQBpDsnXpvK4vA';
        this.mapBox = new mapboxgl.Map({
          container: 'mapBox',
          center: [this.locationData[0].longitude, this.locationData[0].latitude],
          zoom: 12,
          style: 'mapbox://styles/mapbox/streets-v11',
        });

        this.renderMarker();
        // this.renderPopup();

        // const popup = new mapboxgl.Marker({
        //   element: '<img src="../../static/images/lo.png">',
        // }).setLngLat([this.long_lat[0].longitude, this.long_lat[0].latitude])
        //   .addTo(this.mapBox);


        // setTimeout(() => {
        //   if( Microsoft ){
        //     if(this.long_lat.length){
        //       this.map = new Microsoft.Maps.Map('#bing_map', {
        //         zoom: 12,
        //         center: new Microsoft.Maps.Location(this.long_lat[0].latitude, this.long_lat[0].longitude),
        //       });
        //       this.infobox = new Microsoft.Maps.Infobox(this.map.getCenter(), {
        //         visible: false,
        //         showCloseButton: false,
        //         offset: new Microsoft.Maps.Point(0, -2),
        //       });
        //
        //       this.infobox.setMap(this.map);
        //       this.addShape();
        //       // let pushpin = new Microsoft.Maps.Pushpin(this.map.getCenter(), { icon: icon,
        //       //   anchor: new Microsoft.Maps.Point(20, -60) });
        //       // this.map.entities.push(pushpin);
        //     }else{
        //       this.map = new Microsoft.Maps.Map('#bing_map', {
        //         zoom: 12
        //       });
        //       this.getCurrentPosition()
        //     }
        //   }
        // }, 500)
      },

      /** 显示地图 */
      renderMarker(){
        // if (course_list.length === 1) {
        //   markerTpl = document.createElement('img');
        //   markerTpl.src = './templates/images/course/lo.png';
        // }else{
        //   var arrow = '<div class="arrows"></div>';
        //   var content = `<div>${labelPrice}</div>`;
        //
        //   markerTpl = document.createElement('div');
        //   markerTpl.className = 'marker-wrp';
        //   markerTpl.innerHTML = arrow + content;
        // }


        // if(this.singleLocation){
        //   var el = document.createElement('img');
        //
        //   el.setAttribute('src', '/static/images/lo.png');
        //   el.style.width = '34px';
        //   el.style.height = '48px';
        //
        //   let map = new mapboxgl.Marker(el)
        //     .setLngLat([this.locationData[0].longitude, this.locationData[0].latitude])
        //     .addTo(this.mapBox);
        // }else{
          let popup = new mapboxgl.Popup({maxWidth: '600px', className: ''});

          this.locationData.forEach((item, idx) => {
            
            let labelPrice = (item.min_price && item.min_price.price) ? ((item.tax_fee && item.tax_fee > 0) ? parseInt(Number(item.min_price.price) + Number(item.tax_fee)): parseInt(Number(item.min_price.price))): '';
            let labelCurrencyCode = (item.min_price && item.min_price.currency_code) ? item.min_price.currency_code : 'CNY';
            let markerTpl;
            // let arrow = '<div class="arrows"></div>';

            if (this.locationData.length === 1) {
              markerTpl = document.createElement('img');
              markerTpl.src = '/static/images/lo.png';
              // popup.setHTML(this.renderPopup(item)).setLngLat([item.longitude, item.latitude]).addTo(this.mapBox);
            }else{
              markerTpl = document.createElement('div');

              let arrow = '<div class="arrows"></div>';
              let content = labelPrice ? `<div>${labelCurrencyCode}${labelPrice}</div>` : this.$t('hotel.PHONE_ASK');

              markerTpl = document.createElement('div');
              markerTpl.className = 'marker-wrp';
              markerTpl.innerHTML = arrow + content;
            }

            // if(labelPrice){
              // let content = `<div>${labelCurrencyCode} ${labelPrice}</div>`;
              //
              // markerTpl.className = 'marker-wrp';
              // markerTpl.innerHTML = arrow + content;

              let mk = new mapboxgl.Marker(markerTpl)
                .setLngLat([item.longitude, item.latitude])
                .addTo(this.mapBox);

              markerTpl.addEventListener('mouseover', () => {
                popup.remove();
                popup.setHTML(this.renderPopup(item)).setLngLat([item.longitude, item.latitude]).addTo(this.mapBox);

                document.querySelector('.hotel-info-box').removeEventListener('click', this.onLink);
                document.querySelector('.hotel-info-box').addEventListener('click', this.onLink, false);
              }, false);

              // markerTpl.addEventListener('mouseleave', () => {
              //   document.querySelector('.hotel-info-box').removeEventListener('click', this.onLink, false);
              // }, false);
            // }
          });

          // document.querySelector('.marker-wrp').addEventListener('click', (ev) => {
          //   console.log(ev.target.classList[0]);
          //   if(ev.target.classList[0] === 'hotel-info-box'){
          //     let id = ev.target.getAttribute('data-hotel-id');
          //     this.onLink(id);
          //   }
          // });
        // }
      },

      /** 生成价格标记点 */
      renderPopup(item){
        // this.locationData.forEach((item, idx) => {
        //   let labelPrice = (item.min_price && item.min_price.price) ? ((item.tax_fee && item.tax_fee > 0) ? Number(item.min_price.price) + Number(item.tax_fee): Number(item.min_price.price)): '';
        //   let labelCurrencyCode = (item.min_price && item.min_price.currency_code) ? item.min_price.currency_code : '';
        //
        //   if(labelPrice){
        //     new mapboxgl.Popup({closeButton: false, closeOnClick: false})
        //       .setLngLat([item.longitude, item.latitude])
        //       .setText(labelCurrencyCode + labelPrice)
        //       // .setDOMContent(div)
        //       .addTo(this.mapBox);
        //   }
        // });
        let $html = `
               <div class="hotel-info-box" style="cursor: pointer;" data-hotel-id="${item.hotel_id}">
                  <div class="img-wrapper inline-block">
                    <img src="${item.img_url?item.img_url:'https://cdn.jalan.jp/jalan/images/pict2L/Y0/Y303560/Y303560045.jpg'}" alt="">
                  </div>
                  <div class="info-content inline-block">
                    <div class="hotel-name">${item.hotel_name}</div>
                    <div class="hotel_name_en">${item.hotel_name_en}</div>
                    
                    <div class="star-wrapper">`;

        let star_icon = '/static/images/start_level.png';

        for (var j = 0, starNum = Number(item.star_rating); j < starNum; j++) {
          $html+= `<img src="${star_icon}" alt="">`
        }

        $html+= `</div>`;
        // $html += `<div >B.C.C减CNY 367起</div>`
        // $html += '<div >'+this.$t('hotel.TAXES_INCL')+' 7941 '+this.$t('hotel.ABOVE')+'</div>'
        if(item.min_price.price){
          $html += `<div class="bccDisCount"><img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAB40lEQVQoU11ST0jUQRh987OWNSnc/EMtSBBFUOFC2628dvNUUHdPbYc6CJGE/PAgHbwIKpUIEdQl8JAHIYTokEUlJCTlSsRKtLFK64prO/P75vtk5rcbrXOZGea9ee9736ewb20tPctatoNMBiAz1tWXW/ofohqX7U/POyOFUbZmQMgETBpCmiWqzcDQULo/3HRYJRIG5eWzObbRiJBJOWAdXN8N2OqyWD18Yjk1pf58fjHBVLvlLEgdHBxIejBVN8CRdgRI/D6pNj8+1Uw6Ef9qPDDZfQZiI1TXP3iC2FiVyRhVWnws7nL4ZB8qq69g9Q6OZq5B2GLj/bRzjVTmKkpvH3oHqvhmXNwh0d6D1mPn8Pf3Cjou3PBZlN5N41C6F5W119j5segdqF8LD7yCMCF95T6ClkRT0K62tSfXwaYaK/ycD2MCaXRfuolk16kmwm5xBYXZ23Fi1kAVXt7VYk3CFdd6/DwOtnV4NVeDWIIpF1DJLzSKN2p99s4ERS5WjbaeLFqSRzwBjsAWZruIrS9zXgFiJ5WEYfD9dCEnVBth0r5xjX44C3Gspgym4Qzlp/6Nxuqj/k5WPCqmNsCkA0cSq1lsNBMZO3QxzMejsX/4vo5fzlKkB113FZux3nvfmoZvD/vxZx4pa0b+AAAAAElFTkSuQmCC' />B.C.C减CNY ${item.bcc_discount_amount}${this.$t('hotel.ABOVE')}</div>
          <div class="totalPrice">
            ${item.tax_fee==0?this.$t('hotel.TAXES_INCL'):''}
            ${item.min_price.currency_code}<span style="font-size:18px;font-weight:700;"> ${parseInt(item.min_price.price)}</span>${this.$t('hotel.ABOVE')}`
          if(item.tax_fee>0){
            $html =+  `<div>${this.$t('hotel.Additional_Tax')}${item.min_price.currency_code} ${item.tax_fee}</div>
            `
          }    
        }else{
          $html +=`<div style="text-align: right;font-size: 16px;font-weight: 600;">${this.$t('hotel.PHONE_ASK')}</div>`
        }
        $html +='</div>'  
        if (item.score && item.score > 0) {
          $html +=
            `<div class="hotel-score-wrapper">
                     <div class="hotel-score">
                      <div class="score">${item.score}</div>
                    </div>`;
        }
        $html+= `</div></div>`;

        return $html;
      },

      // 生成球场坐标点
      addPoints() {
        for (var i = 0, longLatL = this.long_lat.length; i < longLatL; i++) {
          if (this.long_lat[i].latitude != '' && this.long_lat[i].longitude != '')
            this.points[i] = new Microsoft.Maps.Location(this.long_lat[i].latitude, this.long_lat[i].longitude);
        }
      },

      //  生成坐标点信息框
      /*addShape() {
        this.addPoints();
        for (var i = 0, longLatL = this.long_lat.length; i < longLatL; i++) {
          const item = this.long_lat[i];
          const hotelNameEn = this.lanType !== 4 && item.hotel_name !== item.hotel_name_en ? item.hotel_name_en : '';
          let $html = `
               <div class="hotel-info-box">
                  <div class="img-wrapper inline-block">
                    <img src="http://cdn.jalan.jp/jalan/images/pict2L/Y0/Y303560/Y303560045.jpg" alt="">
                  </div>
                  <div class="info-content inline-block">
                    <div class="hotel-name">${item.hotel_name}</div>
                    <div class="hotel_name_en">${hotelNameEn}</div>
                    <div class="star-wrapper">`;

          for (var j = 0, starNum = Number(item.star_rating); j < starNum; j++) {
            $html+= `<img src="${star_icon}" alt="">`
          }

          $html += `</div></div>`;

          if (item.score && item.score > 0) {
            $html+=
                  `
                  <div class="hotel-score-wrapper">
                     <div class="hotel-score">
                      <div class="score">${item.score}</div>
                    </div>`;
          }
          $html+=`</div></div>`;

          let labelPrice = (item.min_price && item.min_price.price) ? ((item.tax_fee && item.tax_fee > 0) ? Number(item.min_price.price) + Number(item.tax_fee): Number(item.min_price.price)): '';
          let labelCurrency_code = (item.min_price && item.min_price.currency_code) ? item.min_price.currency_code : '';
          let labelText =  labelCurrency_code + ' ' + labelPrice ;
          let xIcon = svg.join('');
          let anchor = new Microsoft.Maps.Point(40, 15);
          /!** 酒店详情页的地图弹窗显示默认图标 **!/
          if (this.long_lat[0].hotel_detail) {
            xIcon = icon;
            anchor = new Microsoft.Maps.Point(15, 15);
            labelText = '';
          }
          let pushpin = new Microsoft.Maps.Pushpin(this.points[i], {
            icon: xIcon,
            text: labelText,
            anchor: anchor,
          });

          pushpin.metaData = {
            htmlContent: $html,
            hotel_id: item.hotel_id
          };

          Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', this.pushpinMouseOver);
          Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', this.pushpinMouseOut);

          this.map.entities.push(pushpin);
        }
      },*/

      /** 获取用户当前位置经纬度 */
      getCurrentPosition(){
        navigator.geolocation.getCurrentPosition(function (position) {
          let loc = new Microsoft.Maps.Location(position.coords.latitude, position.coords.longitude);

          this.map.setView({center: loc});
        });
      },

      /** 移入地图图标回调函数 */
      pushpinMouseOver(e){
        const curInfoBox = e.target;
        var svg_red = ['<svg xmlns="http://www.w3.org/2000/svg" width="80" height="40"><rect width="', 80, '" height="', 25, '" rx="2" ry="2" stroke="', '#FD4700', '" stroke-width="', 1, '" fill="', '#FD4700', '"/><polygon points="34,23,48,23,41,33" style="fill:#FD4700; stroke: #FD4700; stroke-width: 1"/></svg>'];

        /** 不是酒店详情页 **/
        if (!this.long_lat[0].hotel_detail) {
          curInfoBox.setOptions({visible: true, icon: svg_red.join('')});
        }
        if (e.target.metaData) {
          this.infobox.setOptions({
            location: e.target.getLocation(),
            description: e.target.metaData.htmlContent,
            maxWidth: 1100,
            maxHeight: 600,
            visible: true
          });

          Microsoft.Maps.Events.addHandler(this.infobox, 'click', ev => {
            this.onLink(e.target.metaData.hotel_id);
          });
        }
      },

      /** 移出地图图标回调函数 */
      pushpinMouseOut(e){
        /** 不是酒店详情页 **/
        if (!this.long_lat[0].hotel_detail){
          var curInfoBox = e.target;
          curInfoBox.setOptions({visible: true, icon: svg.join('')});
        }

        if (e.target.metaData) {
          this.infobox.setOptions({
            visible: false
          });
        }
      },

      /** 路由到酒店详情 **/
      onLink() {
        let id = document.querySelector('.hotel-info-box').getAttribute('data-hotel-id');
        let obj = {
          hotel_id: id
        };

        this.$emit('on-link', obj)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .J_map-box{
    position: relative;
    width: 100%;
    height: 100%;
    background: #C8C7CC;

    #mapBox{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .mapboxgl-popup-content{
      background: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MapBox/MapBox.vue